import { alpha, hexToRgb, makeStyles } from "@material-ui/core";

const styles = makeStyles((theme) => ({
  root: {},
  fields: {
    // we're controling the grid's row spacing
    // because HvGrid still doesn't support it to
    // be different from the column spacing.
    "$root &>div": {
      paddingTop: 5,
      paddingBottom: 0,
    },
  },
  dropdownTopSection: {
    maxWidth: 540,
    minHeight: 96,
    "& > div:first-child": {
      alignItems: "flex-end",
      justifyContent: "space-between",
      "& > *:last-child": {
        padding: 0,
      },
    },
  },
  nameInput: {
    minHeight: 86,
  },
  colorPicker: {
    maxWidth: 240,
  },
  radioGroup: {
    width: "100%",
    marginTop: theme.hv.spacing.md,
    overflow: "visible",
  },
  radioGroupIconOption: {
    width: "calc(100% - 32px)",
    marginLeft: 32,
    marginBottom: theme.hv.spacing.xs,
  },
  textareaInput: {
    // !important needed because of https://github.com/visualization-suite/hvs_web/commit/755c0bf101b78b9038c75bfa23598ad6cc32d894#diff-61c28cd2cfcfd2fca70d1e3b7fcf909dd0bb7c1b3fe1c3cdc94444221f49f017R208
    resize: "none !important" as "none",
    overflow: "scroll",
  },

  mapLabel: {
    paddingBottom: 6,
  },
  mapContainer: {
    position: "relative",
  },
  map: {
    width: "100%",

    [theme.breakpoints.up("md")]: {
      position: "absolute",
      height: "92%",
    },
  },
  uploadDescription: {
    paddingLeft: "32px",
    height: "32px",
    fontSize: "12px",
    lineHeight: "32px",
    paddingRight: "10px",
    textOverflow: "ellipsis",
    letterSpacing: "0.02em",
    verticalAlign: "middle",
    fontWeight: 400,
    whiteSpace: "nowrap",
    overflow: "hidden",
  },

  loading: {
    width: "100%",
    height: "100%",
    paddingBottom: 56,
    paddingRight: 14,

    [theme.breakpoints.up("md")]: {
      paddingBottom: 97,
      paddingRight: 0,
    },
  },
  overlay: {
    position: "absolute",
    transition: "background-Color .2s ease",
    zIndex: -1,
    width: "100%",
    height: "100%",
  },
  blur: {
    backgroundColor: alpha(hexToRgb(theme.hv.palette.atmosphere.atmo2), 0.8),
    zIndex: theme.zIndex.drawer,
  },
}));

export default styles;
